import { useEffect, useMemo, useState } from "react";
import { honeyJarsContract } from "config";
import { useContractRead } from "wagmi";
import useGoldlistEntry from "hooks/useGoldlistEntry";

const useGoldlistStatus = (
  address?: string
): [
  claimedCount: number | undefined,
  maxClaim: number | undefined,
  readGoldlistClaimedCount: () => void
] => {
  const goldlistEntry = useGoldlistEntry(address);
  const [claimedCount, setClaimedCount] = useState<number>();

  const [{ data: claimedData }, readGoldlistClaimedCount] = useContractRead(
    {
      addressOrName: honeyJarsContract.address,
      contractInterface: honeyJarsContract.interface,
    },
    "numberClaimedByGoldListAddress",
    {
      args: address,
      skip: true,
    }
  );

  useEffect(() => {
    const count = claimedData?.toNumber() as number;
    if (Number.isInteger(count)) {
      setClaimedCount(count);
    }
  }, [claimedData]);

  useEffect(() => {
    if (goldlistEntry) {
      readGoldlistClaimedCount();
    }
  }, [goldlistEntry, readGoldlistClaimedCount]);

  return useMemo(
    () => [claimedCount, goldlistEntry?.[1], readGoldlistClaimedCount],
    [claimedCount, readGoldlistClaimedCount, goldlistEntry]
  );
};

export default useGoldlistStatus;
